import moment from 'moment'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import getLocale, {Locale} from 'utils/getLocale'

export default function LocalisedDate({date}: {date: string}) {
  const locale: Locale = getLocale(EnvironmentProvider.useCurrency())

  let format = 'dddd D MMMM, YYYY'

  if (locale === 'us') {
    format = 'dddd MMMM D, YYYY'
  }

  if (!date) {
    return null
  }

  return <>{moment(date).format(format)}</>
}
